/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  SET_BEARER (state, accessToken) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.headers.get['Content-Type'] = 'application/json';
  },
  FORGOT_PASSWORD(state, message) {
    state.forgotPassword = message
  },
  RESET_PASSWORD(state, message) {
    state.resetPassword = message
  },
  CHANGE_PASSWORD(state, message) {
    state.changePassword = message
  },
  CONFIRM_ACCOUNT(state, message) {
    state.confirmAccount = message
  }
}
